import { render, staticRenderFns } from "./org-select-pop.vue?vue&type=template&id=2ae8a9e3&"
import script from "./org-select-pop.vue?vue&type=script&lang=js&"
export * from "./org-select-pop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports